import React, { PureComponent } from 'react'
import styled from 'styled-components';
import { Route } from "react-router-dom";
import CupoyRouter from "components/commons/router/CupoyRouter";
import {
  GlobalStyle,
} from 'stylecomponents';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import GameHomeView from 'components/game/GameHomeView';
import GameTransactionView from 'components/game/GameTransactionView';
import GameTempTransaction from 'components/game/GameTempTransaction';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

/**
|--------------------------------------------------
| Components
|--------------------------------------------------
*/

/**
|--------------------------------------------------
| Main Component
|--------------------------------------------------
*/
class GameView extends PureComponent {
  constructor(props) {
    super(props);

    this.getGameStoreCache = this.getGameStoreCache.bind(this);

    const routerState = CupoyRouter.getCurrent();
    const { params } = routerState;

    const {
      gameid = null,
      serverid = null,
    } = params;

    this.state = {
      gameid,
      serverid,
    };
  }

  componentDidMount() {
    window.scrollTo({ top: 0 });
  }
  
  static getDerivedStateFromProps(nextProps, prevState) {

    const {
      gameid: _gameid,
      serverid: _serverid,
    } = prevState;

    const routerState = CupoyRouter.getCurrent();
    const { params } = routerState;

    const {
      gameid,
      serverid,
    } = params;

    if (gameid !== _gameid || serverid !== _serverid) {
      return {
        gameid,
        serverid,
      };
    }

    return null;
  }

  init() {

    const {
      gameid, 
      serverid,
    } = this.state;

    const game = this.getGameStoreCache();

    if(!game){
      this.props.gameActions.getGameDetail({
        gameid,
      });
    }

    if(!serverid){

      const gameSeverListById = this.props.gameSeverListById;
      const { cupoyStateGo } = this.props.webActions;

      if(!gameSeverListById || !gameSeverListById[gameid] || Object.keys(gameSeverListById[gameid]).length === 0){

        this.props.gameActions.getGameServerList({
          gameid: gameid,
        }).then((result)=>{

          cupoyStateGo(CupoyRouter.STATES.TRANSACTIONLIST_SELL,{
            gameid: gameid,
            serverid: result.resultMap.defaultserverid,
          });
        });
      }else{
        cupoyStateGo(CupoyRouter.STATES.TRANSACTIONLIST_SELL,{
          gameid: gameid,
          serverid: serverid || gameSeverListById[gameid][0].gameserverid,
        });
      }   
      return;         
    }
  }

  getGameStoreCache() {
        
    const {
      gameListMap,
    } = this.props;

    const {
      gameid,
    } = this.state;

    const game = gameListMap[gameid];

    return game;
  }

  render() {

    return (
      <GlobalStyle.SubContainer>
        <Container>
          <Route path={CupoyRouter.PATHS.GAME} component={GameHomeView} exact />
          <Route path={CupoyRouter.PATHS.GAME_TRANSACTION} component={GameTransactionView} />
          <Route path={CupoyRouter.PATHS.GAME_TEMP_TRANSACTION} component={GameTempTransaction} exact />
        </Container>
      </GlobalStyle.SubContainer>
    );
  }

  renderLoading = () => (
    <GlobalStyle.LoadingContainer>
      <GlobalStyle.Spin />
    </GlobalStyle.LoadingContainer>
  )

}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
  return {
    sellerMap: state.vitem.sellerMap,
    isloading: state.vitem.isloading,
    gameListMap: state.game.gameListMap,
    gameSeverListById: state.game.gameSeverListById,
  };
};

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
  return {
    webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
    gameActions: bindActionCreators(actionCreators.gameActionCreators, dispatch),
  };
};

/*--------------------------
  export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
  forwardRef: true
})(GameView);